<template>
  <div class="maindiv">
    <img class="wide" src="../assets/banner.png" alt="Front of museum with statue of horse and lava fiend">
    <div class="textsection">
      <div class="welcome">
        <h3>
            Welcome Everyone to Rockcliff Museum, a place where what is being honored and revered is You. This is where 
            your stories and your memories matter more than any items could ever be worth. 
        </h3>
        <h3>
            This museum exists in a game called Wurm Online. It is a huge project with a lot of history, so please take 
            your time perusing this site and all the pages before visiting, so your experience is informed and you get 
            the most out of being there. 
          </h3>
          <h3>
            This is a fansite for the game, and not associated in any other way with the game itself. There is a 
            disclaimer about that at the bottom of this page. 
        </h3>
      </div>

      <div class="discord"><h3 class="sm-title">If you visit, sign the Guestbook if you feel inspired at https://discord.gg/paFQNNdcmx</h3></div>
      
        
      <div class="section howto">
        <h3 class="how-title">If You Read Only One Thing On This Website, Please Read This:</h3><br>
        The point of Rockcliff Museum is to showcase not the items, but the names of the people who made this
        world. This Museum is about all of you. Each item is renamed with the name of the person who created
        it. Please do not right-click examine the items when visiting. Every time an item is examined, there is a
        chance the signature will fade forever, and yours will replace it. I want to avoid that scenario as much as
        I can, so please keep actual examination to a minimum. For a more detailed explanation of this, please
        read The Preservation Process page in full. Thank you!
      </div>

      <div class="section">
        <h3 class="sm-title">Location - K15 on Independence SFI</h3><br>
        Rockcliff Museum is located down the road from Rockcliff Cathedral, on the E side. It is nestled in a corner of the base of Dragon Fang Mountain, and has a stunning view of the sea and Black Dog Island. It is built upon the lands that Tich settled when Independence opened. It is located at K 15, Independence, SFI. For specific directions, please go to the Museum Guide page. 
      </div>
        

      <div class="section"> 
        <h3 class="section-title">Contributors</h3><br> 
        <p><h4>Curator:</h4>
        I'm Nirav, the Curator and creator of Rockcliff Museum, but without the help and dedication of many other folks 
        in Wurm, the Museum would not be nearly as awesome as it is. There are so many of you to thank, from the player 
        who mailed over one item, to those who have contributed more than that. But a few of you have gone above and 
        beyond to make sure this Museum is everything it can be, and I would like to thank them here:    </p>

        <p><h4>Folks Who Have Donated a Lot of Items:</h4>
          Pomeray and Kindrashae have donated over 500 items as well as 
          thousands of imping materials. Vinius and the Kingdom of Macedon, Hughmongus and Skyefox, and Crimsonearth 
          have each donated over 250 items. Shrimpiie has donated over 100 items. Azazelchiara has donated thousands 
          of kilos of dirt for the NFI terrace. The Aaedean Estate has donated thousands of building supplies. The 
          Museum also has received a massive Anonymous donation of both items and materials - including well over half 
          the wagons and 2/3rds of the PVP banners and flags.</p>

        <p><h4>The Builders:</h4>
          In 2022, my skill was not high enough in paving nor masonry to pull off building the Main Building or the 
          Observation Tower. Camaril, Stormblade, Zimgraham, Lyhrinae, Chaoshaze, and Lilychaos all came over to help 
          me make those building designs a reality. Spacy and Yuri have also helped me with parts of buildings that I 
          could not do at my skill level. </p>


        <h4>Terraformers:</h4>
          Both Camaril and Uzetaab spent months carving more of the deed out of the cliff to provide space for current 
          and future displays. They also further terraformed the diagonal road through the museum, and Uzetaab created a 
          new road to get catseyes to the Museum in a more practical way. Nathan helped to make sure the main entrance 
          has a true 300 slope for dramatic effect. <br>
          <div class="center-box"><img class="smaller" src="../assets/s entrance.png" alt="a distant view of the south entrance gate"></div><br>

        <h4>Ambiance:</h4>
          <p>Before the opening day in 2022, all the lamps were colored and placed by Soraya who created an astoundingly 
          magical atmosphere that makes the nighttime Museum Grounds a mystical, exalted world. I have attempted to 
          carry that method over through the expansions. At that same time, Kasumi did all the interior decoration, and 
          while I received a large number of items after that, her foundation is why the interiors are as beautiful as 
          they are, and all expansions have been my attempt to model the interior design based on her example.</p>
        <p>Nalimar took the Gods Display on the 3rd floor of the main building to the next level with her wonderful 
          sense of design and attention to detail. She has also donated a deed token display that fills an entire room 
          in the Observation Tower. The beautiful new NFI building was designed by LadyRae of Cadence. Sidereal is the 
          official Dye Mistress of Rockcliff, and worked with Nirav each year to fill huge dye orders in short amounts 
          of time, and has donated both dyes and transmutation fluid to various Museum Projects. Atheline started 
          running a sermon sheet at the Gala in 2024, allowing the Gala to be a place for priests to gain skill. This 
          year, she designed the interior of the new Rockcliff Temple. Haxd has loaned/donated some very difficult to 
          find items to make sure there are special things in the Museum that few players have seen. Elentari went on 
          a reasonable rampage after the Goblins killed his favorite horse, and has donated so many goblin items that 
          there is an entire terrace devoted to his Goblin Camp Display.</p>
        <p>Uzetaab maintains the Museum harbor deed, Rockcliff Terraces at Fairview. He built the Fairview Inns where 
          Museumgoers can stay during the Gala and throughout the year.</p>
          <div class="center-box"><img class="smaller" src="../assets/view from new bridge.png" alt="view along the north road between 3 large buildings with the the temple in the background"></div><br>

        <p><h4>The Impers:</h4>  
          Hvergi has supported this Museum since day one by imping anything I have sent to him to find sigs since 2019. 
          Both Elentari and Aaedean imped countless items in 2022 and 2023. In 2023, Aaedean was invaluable and imped 
          over 1200 items for signatures just in that year. Killashandra has imped over 1k items each year since 2024, 
          and has dedicated countless hours of her time to this project, always there when I need her. Since the Gala in 
          2023, Uzetaab has been phenomenally supportive, and has imped over 1500 items each year for signatures and for 
          maintenance. His dedication to the Museum is enduring and humbling - he is my compass, ever practical and 
          somehow always knows exactly what I need, even before I do.</p>
        <p>The following folks have helped imp hundreds of items to find signatures and to maintain the displays: 
          Rivenwind, Shenjiwurm, Bunnlose, Gumbo, Teeebomb, Reflekted, Camaril, Seriphina, Spacy, Sweetsusie, Atheline, 
          Nalimar, Edborough, Merfin, Quelon, Kindrashae, Edborough, Virusmd, Goldfinch, Carmenx, Coventina, Fairyshine, 
          and Yuri. Without the folks willing to improve these items, the Museum would be less than half what it is. I 
          extend my deepest thanks to you all.</p>


        <p><h4>Webdesigner:</h4>
          This website is created and maintained by Camaril, who has supported this dream of mine since I first told her 
          about it.</p>

        <p><h4>Folks Who Have Supported in Other Ways:</h4> 
          Thank you to Bunnbunnnn for creating a discord channel and a continuing hang-out place with Guestbook, as well 
          as providing video and content. Thank you to Reddragon for honoring this place at every Gala with his bartending 
          excellence - he does a phenomenal job - you really feel like you are in a tavern. Thank you to Hughmongus who 
          invented the idea of the Albia Taxi Service and has shuttled people for hours on end during the Gala Events since 
          2023. Huge and Humble thank you to every Gala Staff Member - the event could not even remotely happen if I had to 
          run that alone. Huge thank you also to everyone who has donated items for the Gala auctions and give-aways. 
          Crimsonearth is the official Rockcliff Museum PR Representative, and her Twitch streams at the Gala are truly 
          fantastic. I am deeply grateful to her for all her support and all the ways in which she brings awareness to this 
          project. The Rockcliff Museum Annex on Xanadu was built and is maintained by Spacy and Seriphina</p>

      </div>

      <div class="section"> 
        <h3 class="section-title">How to Donate</h3><br>    
        <p>
        As I have said, this museum is for you. All of you. I want you all here, in name, as a signature on an item in this 
        museum. It doesn't matter if you have played for a week, and you made a spindle, or if you are a GM and can bring a 
        fantastic adamantine sculpture. I want something of yours here, because you all matter, and you all made this 
        beautiful world, and you all deserve to be remembered. You may also send or deliver items intended to be here on loan. 
        If you do that, you will get written confirmation that your item is on loan, and it will be returned to you at the 
        specified date. </p>
        <p>
        I also want your stories. You can't directly post stories, because that would be pretty epic to manage, but you 
        can send them to me so I can put your stories here. Your stories can be about your item here, or just about you 
        and your favorite thing you did in the game. Don't limit yourself, please. If there is a story you want to tell, 
        tell it. Send it to me, Nirav, on the wurm forum 
        <a href="https://forum.wurmonline.com/index.php?/profile/76620-nirav/">https://forum.wurmonline.com/index.php?/profile/76620-nirav/</a>. 
        You and your stories are everything this world is made of. Before donating, an item or an item with a story, I ask that 
        you please go to the page titled “Preservation Process” and look it over. </p>
      </div>

      <div class="center-box"> 
        <img class="large-img" src="../assets/pmk wagons.png" alt="player made kingdom wagons in a row at night">
      </div>

      <div id="footer" > 
        Wurm Online is a game produced by Code Club AB. Wurm Online and Code Club AB do not endorse and are not responsible 
        or liable for any content, products, services or information available on www.rockcliffmuseum.com. This website is not 
        connected to Wurm Online nor is it the official website. Please visit the Wurm Online Official Site at www.wurmonline.com
      </div>

      <br> &nbsp; <br> 
      
    </div>
    
    
  </div>
</template>


<script>
  export default {
    name: 'MuseumHome'
  }
</script>


<style scopped>  

.welcome {
  display: block;
  margin: auto;
  /* text-align: center; */
  margin-top: 10px;
  border: 1px solid orange;
  padding: 10px;
}

#footer {
  /* background-color: black;
  color: white;
  width: calc(100vw - 5px);*/
  border-top: 2px solid rgb(47, 60, 126);
  padding: 20px; 
  margin-top: 80px;
}
.discord {
  width: fit-content;
  margin: auto;  
  margin-top: 10px;
}
</style>